import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from 'react-toastify'
import axios from "axios";
import { useStripe, CardCvcElement, useElements } from "@stripe/react-stripe-js";
import { Country, State, City } from "country-state-city";
import { CardElement } from "@stripe/react-stripe-js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { AuthContext } from "../helpers/AuthContext";
import PageHeaderWithBreadcrumbs from "../components/PageHeaderWithBreadcrumbs";
import LoopIcon from '@mui/icons-material/Loop';
import Select from "react-select";
import { buildNewPasswordSchema } from "../helpers/passwordValidation";

const CompleteRegistration = ({ paymentFailedStatus }) => {
  let { instanceUniqueId } = useParams();
  const { setAuthState } = useContext(AuthContext);
  const [cvcError, setCvcError] = useState(null);
  const [cardInfo, setCardInfo] = useState({
    name: "",
    expiry: "",
    number: "",
    address: {
      line: "",
      postalCode: "",
    },
  });
  const [locations, setLocations] = useState({ countries: "", states: "", cities: "" });
  const [selectedLocation, setSelectedLocation] = useState({ country: {}, city: {}, state: {} });
  const [loadingAnimation, setLoadingAnimation] = useState({active: false, message: "Loading"})
  const [buttonDisable, setButtonDisable] = useState(false)
  const [theCardChange, setTheCardChange] = useState(null);

  let history = useHistory();
  const disableSubmissionButton = useRef();
  const stripe = useStripe();
  const elements = useElements();
  const card = useRef();
  const { authState } = useContext(AuthContext);
 
  const initialValues = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    name: "",
    address: "",
    businessName: ""
  };

  function onCardChange(e) {
    setTheCardChange({ error: e.error })
  }

  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
  const validationSchema = Yup.object().shape({
      first_name: 
        Yup.string()
        .min(2, "Your first name must be a minimum of 5 characters.")
        .max(15, "Your first name must be a maximum of 5 characters.")
        .matches(/^[a-zA-Z]*$/, "Your first name may only contain letters.")
        .required("You must provide a first name that is between 2 to 15 characters."),
      last_name: 
        Yup.string()
        .min(2, "Your last name must be a minimum of 2 characters.")
        .max(20, "Your last name must be a maximum of 20 characters.")
        .matches(/^[a-zA-Z]*$/, "Your last name may only contain letters.")
        .required("You must provide a last name that is between 2 to 20 characters."),
      email: 
        Yup.string()
        .email("You must provide a valid email address.")
        .min(5, "Your email address must be a minimum of 5 characters.")
        .max(60, "Your email address must be a maximum of 60 characters.")
        .required("You must provide an email address that is between 4 to 60 characters."),
      password: buildNewPasswordSchema(),
      // Payment details
      name: 
        Yup.string()
        .min(3)
        .max(24)
        .required("You must provide a valid cardholder name between 3 to 24 characters."),
      businessName: 
        Yup.string("You must provide a business name that doesn't exceed 100 characters.")
        .max(100, "You must provide a business name that doesn't exceed 100 characters."),
      address: 
        Yup.string()
        .min(4, "Your address must be a minimum of 4 characters.")
        .max(80, "Your address must be a maximum of 80 characters.")
        .required("You must provide an address between 4 to 80 characters.")
  });

  function parseForSelect(arr) {
    return arr.map((item) => ({
      label: item.name,
      value: item.isoCode ? item.isoCode : item.name,
    }));
  }

  function handleSelectCountry(country) {
    const states = State.getStatesOfCountry(country.value);
    setSelectedLocation((prev) => {
      return { ...prev, country };
    });

    setLocations((prev) => ({ ...prev, states: parseForSelect(states) }));
  }

    function handleChangePostalCode(e) {
        const { value } = e.target;
        setCardInfo((prev) => {
        return { ...prev, address: { ...prev.address, postalCode: value } };
        });
     }

  function handleSelectState(state) {
    const cities = City.getCitiesOfState(selectedLocation.country.value, state.value);
    setSelectedLocation((prev) => {
      return { ...prev, state };
    });

    setLocations((prev) => ({ ...prev, cities: parseForSelect(cities) }));
  }

  function handleSelectCity(city) {
    setSelectedLocation((prev) => {
      return { ...prev, city };
    });
  }

  const onSubmit = (data) => {
    setButtonDisable(true)
    // User has been successfully created 
    stripe.createToken(elements.getElement(CardElement))
    .then((result) => {
      // Verify that the card is valid
      if (result.error) {
        setCvcError(result.error.message);
        toast.error(cvcError, {
          toastId: 3
        })
        setButtonDisable(false)
        setLoadingAnimation({active: false, message: null})
      } else {
        alert("Card is verified")
        // Card is verified, create payment method
        axios
        .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/verifyemailexists`, {
          params: {
            emailAddressToCheck: data.email
          }
        }).then(emailStatus => {
          // If the email exists
          if(emailStatus.data == true){
            alert("The email already exists")
          // If the email doesn't exist
          } else if (emailStatus.data == false){
            alert("Creating user")
            axios.post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/create-new-user`, { 
              data 
            }).then(NewlyCreatedUser => {
              const address = cardInfo.address;
              const billingDetails = {
                name: data.name,
                address: {
                  country: selectedLocation.country.value,
                  state: selectedLocation.state.value,
                  city: selectedLocation.city.value,
                  line1: data.address,
                  postal_code: address.postalCode,
                },
                email: data.email,
                phone: data.phone_number
              };

              setLoadingAnimation({active: true, message: `Verifying payment method.`})
              // Card is verified, create payment method
              alert("Where are we?")
              stripe
              .createPaymentMethod({
                type: "card",
                billing_details: billingDetails,
                card: elements.getElement(CardElement),
              }).then((paymentMethodResponse) => {  
                alert("Confirm the card setup")
                console.log(JSON.stringify(NewlyCreatedUser))
                // Payment method retrieved, create a payments intents     
                axios.post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/confirm-card-setup`, { 
                  userId: NewlyCreatedUser.data.userId,
                  paymentMethod: paymentMethodResponse.paymentMethod,
                  createStripeCustomerAccount: true,
                  businessName: data.businessName
                }).then((paymentStatus) => {
                  if(paymentStatus.data.cardPaymentSuccessful == true){
                    setLoadingAnimation({active: true, message: `Payment method has been validated`})
                    toast.success("The card is valid.", {
                      toastId: 2
                    })
                    const activateInstance = new FormData()
                    activateInstance.append('instanceUniqueId', instanceUniqueId) 
                    activateInstance.append('stripeUserId', paymentStatus.data.StripeUserId)
                    var meggedObj = {}
                    // add the form key/value pairs
                    for (var pair of activateInstance.entries()) {
                      meggedObj[pair[0]] = pair[1];
                    }

                  } else if (paymentStatus.data.cardPaymentSuccessful == false) {
                    toast.error("The card was not valid. Please retry.", {
                      toastId: 1
                    })
                    setLoadingAnimation({active: false, message: null})
                    setButtonDisable(false)
                  }
                }) // Payment Intents Response
              }) // PaymentMethod Response
            }) // Newly created user
          } // If email doesn't exist
        })
      } // Verify card is valid
    }) // After token
  }
  useEffect(() => {
    const allCountry = Country.getAllCountries();

    setLocations((prev) => {
      return { ...prev, countries: parseForSelect(allCountry) };
    });
  }, []);

  return (
    <div>
      <ToastContainer/>
      <div className="rightSide">
        <div className="options-container no-wrap">
          <div className="options-inner-container w-60">
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
          <Form className="registration-form-container fade-in-effect-usability">

          <div className="paymentForm paymentForm-home">
            { loadingAnimation.active == true ?
              <div className="loading-animation fade-in-effect-usability" style={{position: "absolute", borderRadius: "15px"}}>
                <span className="loading-label"><span className="loading-message">{loadingAnimation.message}</span><LoopIcon className="rotating"/></span>
              </div>
            : 
              ""
            }
            <h2>Revolutionize your lead generation with Elite Core.</h2>
            <p>Cutting-edge AI Live Core software that converts. <b>Start your 7-day free trial today</b> and see how Elite Core can help you capture and convert more leads than ever before!</p>
            <div className="options-row">









            <div className="options-col-half">
                <div className="options-col-inner">
                    <label>First name</label>
            <ErrorMessage name="first_name" component="span" />
            <Field
              autocomplete="off"
              id="inputCreatePost"
              name="first_name"
              placeholder="John"
            />
          </div>
          </div>
          <div className="options-col-half">
                <div className="options-col-inner">            <label>Last name</label>
            <ErrorMessage name="last_name" component="span" />
            <Field
              autocomplete="off"
              id="inputCreatePost"
              name="last_name"
              placeholder="Doe"
            />
          </div>
          </div>
          <div className="options-col-half">
                <div className="options-col-inner">
                              <label>Email address</label>
            <ErrorMessage name="email" component="span" />
            <Field
              autocomplete="off"
              id="inputCreatePost"
              name="email"
              placeholder="example@gmail.com"
            />
          </div>
          </div>
          <div className="options-col-half">
                <div className="options-col-inner">            <label>Password</label>
            <ErrorMessage name="password" component="span" />
            <Field
              autocomplete="off"
              type="password"
              id="inputCreatePost"
              name="password"
              placeholder="************"
            />
          </div>
          </div>






              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Cardholder name</label>
                  <ErrorMessage name="name" component="span" />
                  <Field
                  autocomplete="off"
                  id="inputCreatePost"
                  name="name"
                  type="text"
                  placeholder="John Doe"
                  />
                </div>
              </div>
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Address</label>
                  <ErrorMessage name="address" component="span" />
                  <Field
                    type="text"
                    name="address"
                    placeholder="Enter the address associated with your card."
                  />
                </div>
              </div>
            </div>
            
            <div className="options-row">
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Country</label>
                  <Select
                      className="select-container-v2"
                      isSearchable={false}
                      name="country"
                      value={selectedLocation.country !== null ? selectedLocation.country : "Type to search for your country"}
                      options={locations.countries}
                      onChange={handleSelectCountry}
                    />
                </div>
              </div>
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>State or province</label>
                  <Select
                      className="select-container-v2"
                      isSearchable={false}
                      name="state"
                      value={selectedLocation.state}
                      options={locations.states}
                      onChange={handleSelectState}
                    />
                </div>
              </div>
            </div>

            <div className="options-row">
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>City</label>
                  <Select
                    className="select-container-v2"
                    isSearchable={false}
                    name="city"
                    value={selectedLocation.city}
                    options={locations.cities}
                    onChange={handleSelectCity}
                  />
                </div>
              </div>
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Postal code</label>
                  <input
                    onChange={handleChangePostalCode}
                    type="text"
                    name="postalCode"
                    placeholder="Enter postal code"
                  />
                </div>
              </div>
            </div>     


            <div className="options-row">
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Business name</label>
                  <ErrorMessage name="businessName" component="span" />
                  <Field
                    type="text"
                    name="businessName"
                    placeholder="Enter your business name"
                  />
                </div>
              </div>
              <div className="options-col-half">
                <div className="options-col-inner">
                  <label>Phone number</label>
                  <ErrorMessage name="email" component="span" />
                  <Field
                    autocomplete="off"
                    id="inputCreatePost"
                    name="phone"
                    placeholder="7809998888"
                  />
                </div>
            </div> 
          </div>

            <div className="options-row">        
              <div className="options-col-inner">
              <span id="card-errors" role="alert">{theCardChange && theCardChange.error != null ? theCardChange.error.message : ""}</span>

                <div className="paymentMethodSetupContainer">
                  <CardElement 
                    ref={card} 
                    onChange={onCardChange}                  
                  />
                </div>
              </div>
            </div>

            {/*<h2 className="registerForm-cta-heading">Confirm payment.</h2>
            <p className="registerForm-cta-paragraph">Upon clicking confirm, your selected payment card will be charged <strong>$99</strong> as a standard initilization fee. By clicking confirm, you agree to our terms and conditions.</p>
            <div className="browse-cart">
              <span className="item-cost">$99 support core initialization <b>x1</b></span>
            </div>*/}      
            {paymentFailedStatus == false ?
            <>
              <div className="options-row">        
                <div className="options-col-inner">
                  <h2>Confirm card.</h2>
                  <p>Upon clicking confirm, your selected payment card will be charged every seven days for all leads generated by our support agents. By clicking confirm, you agree to our terms and conditions.</p>
                  <div className="browse-cart">
                    <span className="item-cost">Support core initialization <b>x1</b> - <b>($0)</b></span>
                  </div> 
                  <button disabled={buttonDisable} className="ec-button" type="submit"> Confirm payment</button>
                </div>
              </div>
            </>
            :
            <>
            <div className="options-row">        
              <div className="options-col-inner">
                <h2>Confirm payment method addition</h2>
                <p>Upon clicking confirm, your selected payment method will be assigned as the default payment method for your account. All associated live core instances that you own under this account will be charged from this card going forward. By clicking confirm, you agree to our terms and conditions.</p>
                <button className="ec-button" type="submit"> Confirm payment method addition</button>
              </div>
            </div>
            </>
            }
      </div>
            </Form>
        </Formik>
    </div>
    <div className="options-inner-container w-40">
      <div className="home-case-study-inner">
        <img src="/rubber-kings-paving-logo.png"/>
        <h2>"We can't take any more leads"</h2>
        <h5>Learn how we generated dozens of leads for a server item worth $20,000</h5>
        <p>Rubber Kings Paving, a leading rubber paving company in Edmonton, Alberta, Canada, was struggling to generate quality leads from their website. Despite having a steady stream of visitors, they were unable to convert them into paying customers, resulting in missed opportunities and lost revenue.

That's when they turned to Elite Core for help. Our team of AI experts worked closely with Rubber Kings Paving to understand their unique business needs and design a custom-tailored live core bot that dynamically evolved to match their brand's voice and tone.</p>
    
</div>
    </div>
    </div>

    </div>

  </div>
  );
}

export default CompleteRegistration;
